import React from "react";
import style from "../../Styles/Components/DistributionHistory.module.css";

import DistributionCard from "./DistributionCard";

const DistributionHistory = ({ histories, ELocale }) => (
  <div className={style.container}>
    {histories &&
      histories.map((history, index) => (
        <DistributionCard
          history = {history}
          ELocale = {ELocale}
          isFirst={index === 0}
          isLast={index === histories.length - 1}
          key={index} {...history} onClick={history.onClick} isOpen={history.isOpen}
        />
      ))}
  </div>
);

export default DistributionHistory;
